module.exports = require("./dje.d.ts");